// Auto generated, DO NOT MODIFY
export enum TransferScopeEnum {
    'ALL' = '0',
    'INTRA_FIRM' = '1',
    'INTER_FIRM' = '2'
}

type TransferScopeEnumMap = Record<
    keyof typeof TransferScopeEnum,
    {
        keyName: string;
        value: string;
        displayValue: string;
    }
>;

export const TransferScopeEnumMap: TransferScopeEnumMap = {
    'ALL': {
        'keyName': 'ALL',
        'displayValue': 'All',
        'value': '0'
    },
    'INTRA_FIRM': {
        'keyName': 'INTRA_FIRM',
        'displayValue': 'IntraFirm',
        'value': '1'
    },
    'INTER_FIRM': {
        'keyName': 'INTER_FIRM',
        'displayValue': 'InterFirm',
        'value': '2'
    }
};